import mixpanel from "mixpanel-browser";
import { getEnvConfig } from "helpers/environment-config";

let projectToken;

const safeExecute = fn => (...args) => {
  if (projectToken) {
    return fn(...args);
  }

  return undefined;
};

export const initMixpanel = async () => {
  projectToken = await getEnvConfig("mixpanelProjectToken");
  safeExecute(mixpanel.init)(projectToken, { persistence: "localStorage" });
};

export const trackLogin = safeExecute(distinctId => mixpanel.identify(distinctId));

export const trackLogout = safeExecute(() => mixpanel.reset());

export const trackPageView = safeExecute(() => mixpanel.track("Page Viewed", { page: window.location.pathname }));

export const trackReminderSave = safeExecute(() => mixpanel.track("Reminder Saved"));

export const trackLoanSummariesDownload = safeExecute(() => mixpanel.track("Loan Summaries Downloaded"));

export const trackFileAttachmentToLCTask = safeExecute(() => mixpanel.track("File Attached To Task (LC)"));

export const trackLCTaskCompletion = safeExecute(() => mixpanel.track("Task Marked Completed (LC)"));

export const trackLCReportSubmit = safeExecute(() => mixpanel.track("Report Submitted (LC)"));

export const trackLCReportApprove = safeExecute(() => mixpanel.track("Report Approved (LC)"));

export const trackLCReportShare = safeExecute(() => mixpanel.track("Report Shared (LC)"));
